
export const ERROR_QUERYING_NOTIFICATIONS = 'ERROR_QUERYING_NOTIFICATIONS';
export const QUERYING_NOTIFICATIONS = 'QUERYING_NOTIFICATIONS';
export const RECEIVED_NOTIFICATIONS = 'RECEIVED_NOTIFICATIONS';

export const INITIAL_CHECK_FOR_PUBLICATION_CHANGES_COMPLETE = 'INITIAL_CHECK_FOR_PUBLICATION_CHANGES_COMPLETE';
